import { useMemo } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";
import moment from "moment";

// Field names exactly as the API returns them.
// summable: false for snapshot/cumulative values that shouldn't be added across days.
const COLUMNS = [
    { field: "active_base", header: "Active Base", summable: false },
    { field: "new_subscriptions", header: "New Subscriptions", summable: true },
    { field: "sub_revenue", header: "Subscription Revenue", summable: true },
    { field: "sub_charge", header: "Subscription Charged", summable: true },
    { field: "renewals", header: "Renewals", summable: true },
    { field: "ren_revenue", header: "Renewal Revenue", summable: true },
    { field: "unsub", header: "Unsubscriptions", summable: true },
    { field: "day_revenue", header: "Day Revenue", summable: true },
    { field: "month_revenue", header: "Month Revenue", summable: false },
];

const formatNumber = (value) => Number(value ?? 0).toLocaleString("en-US");

const RevenueTable = ({ data = [] }) => {
    const totals = useMemo(() => {
        const result = {};
        COLUMNS.forEach(({ field, summable }) => {
            result[field] = summable
                ? data.reduce((sum, row) => sum + (Number(row[field]) || 0), 0)
                : null;
        });
        return result;
    }, [data]);

    const footerGroup = (
        <ColumnGroup>
            <Row>
                <Column footer="Total" frozen alignFrozen="left" />
                <Column footer="" frozen alignFrozen="left" />
                {COLUMNS.map(({ field }) => (
                    <Column
                        key={field}
                        footer={totals[field] === null ? "—" : formatNumber(totals[field])}
                    />
                ))}
            </Row>
        </ColumnGroup>
    );

    return (
        <DataTable
            value={data}
            footerColumnGroup={data.length ? footerGroup : undefined}
            emptyMessage="No revenue data for the selected dates or services."
            showGridlines
            stripedRows
            scrollable
            scrollHeight="600px"
            paginator
            rows={40}
            rowsPerPageOptions={[20, 40, 100]}
            sortField="date_time"
            sortOrder={-1}
        >
            <Column
                field="date_time"
                header="Date"
                sortable
                frozen
                alignFrozen="left"
                body={(row) => moment(row.date_time).format("DD MMM YYYY")}
            />
            <Column
                field="service_name"
                header="Service Name"
                sortable
                frozen
                alignFrozen="left"
            />
            {COLUMNS.map(({ field, header }) => (
                <Column
                    key={field}
                    field={field}
                    header={header}
                    sortable
                    body={(row) => formatNumber(row[field])}
                />
            ))}
        </DataTable>
    );
};

export default RevenueTable;